module.exports = __webpack_public_path__ + "static/img/IMG_0363.166b74c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/news/IMG_0363.jpg
// module id = RS68
// module chunks = 1